import { Box, Typography } from '@mui/material';
import Link from 'components/Link';
import { useRouter } from 'next/router';
import { EmailStepInputs, StepOneInputs } from 'pages/register';
import { SubmitHandler, useForm } from 'react-hook-form';
import { ToastContainer } from 'react-toastify';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { BigButton } from '../Buttons/BigButton';
import { PasswordInput, TextInput } from '../TextInput';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useState } from 'react';
import { EmailSent } from './EmailSent';
import { RoleBox } from '../RoleBox';
import { useCampaign } from 'context/campaign.context';
import { useRedirectUrl } from 'context/redirectUrl.context';

interface EmailSignupProps {
  emailSignUpData: StepOneInputs;
}

export const EmailSignup = ({ emailSignUpData }: EmailSignupProps) => {
  const router = useRouter();
  const queryReferralCode = router.query.referral_code as string | undefined;
  const [success, setSuccess] = useState<boolean>(false);
  const [role_id, setRole_id] = useState<1 | 2>(1);
  const [redirectUrl] = useRedirectUrl();
  // const campaign = router.query.campaign as string | undefined;
  const campaign = useCampaign();

  const schema: yup.SchemaOf<EmailStepInputs> = yup.object().shape({
    referrer_code: yup
      .string()
      .notRequired()
      .matches(/^(POD|pod)[a-zA-Z0-9]{7}\s*$/, {
        message: 'Invalid referral code',
        excludeEmptyString: true,
      }),
    password: yup
      .string()
      .min(8, 'Password length should be more than or equal to 8')
      .required('Password is required')
      .matches(
        /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/i,
        'At least one letter, one number and one special character required',
      ),
    confirm_password: yup
      .string()
      .oneOf([yup.ref('password')], 'Passwords do not match')
      .required('Confirm password is required'),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<EmailStepInputs>({
    resolver: yupResolver(schema),
    defaultValues: {
      referrer_code: queryReferralCode || '',
    },
    mode: 'onTouched',
  });

  const onSubmit: SubmitHandler<EmailStepInputs> = (data) => {
    console.log(data);
    console.log(emailSignUpData);

    const body = {
      ...data,
      ...emailSignUpData,
      role_id,
    };
    delete body.confirm_password;
    console.log('data', body);
    axios
      .post(`${process.env.NEXT_PUBLIC_BACKEND_URL}/api/v1/user/signup`, body, {
        params: {
          campaign,
          redirect_url: redirectUrl ? redirectUrl : undefined,
        },
      })
      .then((res: any) => {
        if (res.data.statusCode === 200) {
          setSuccess(true);
        } else {
          toast.error(res.data.message, {
            autoClose: 5000,
            hideProgressBar: true,
          });
        }
      })
      .catch((err: any) => {
        toast.error(err.message, { autoClose: 5000, hideProgressBar: true });
      });
  };

  if (success) {
    return (
      <EmailSent
        name={emailSignUpData.first_name}
        email={emailSignUpData.email}
      />
    );
  }

  return (
    <Box component="form">
      <ToastContainer />
      <Typography
        component="h1"
        mt="42px"
        color="#091E42"
        fontSize={28}
        fontWeight={700}
        lineHeight="32.81px"
      >
        Sign up
      </Typography>
      <Typography
        mt={1.5}
        fontSize={14}
        lineHeight="21px"
        color="rgba(0, 0, 0, 0.67)"
      >
        Join as
      </Typography>
      <Box display="flex" mt="9px" mb="19px">
        <RoleBox
          sx={{
            bgcolor: role_id == 1 ? '#008B5E' : undefined,
            color: role_id == 1 ? '#fff' : undefined,
          }}
          onClick={() => setRole_id(1)}
        >
          Investors
        </RoleBox>
        <RoleBox
          sx={{
            bgcolor: role_id == 2 ? '#008B5E' : undefined,
            color: role_id == 2 ? '#fff' : undefined,
          }}
          onClick={() => setRole_id(2)}
        >
          Startups
        </RoleBox>
      </Box>
      <Box component="form" onSubmit={handleSubmit(onSubmit)}>
        <TextInput
          placeholder="Referral Code (Optional)"
          register={register('referrer_code')}
          errorMessage={errors.referrer_code?.message}
        />
        <PasswordInput
          placeholder="Enter Password"
          type="password"
          register={register('password')}
          errorMessage={errors.password?.message}
          autoComplete="new-password"
        />
        <PasswordInput
          // onChange={(e) => setPassword(e.target.value)}
          placeholder="Confirm Password"
          type="password"
          // inputRef={passwordRef}
          register={register('confirm_password')}
          errorMessage={errors.confirm_password?.message}
          autoComplete="new-password"
        />

        <BigButton
          onClick={handleSubmit(onSubmit)}
          type="submit"
          sx={{ py: '10px', width: '100%' }}
        >
          <Typography fontWeight={700} fontSize={18}>
            SIGN UP
          </Typography>
        </BigButton>
        <Typography mt="17px">
          Already have an account?{' '}
          <Link sx={{ fontWeight: 700 }} noLinkStyle href="/login">
            Login
          </Link>
        </Typography>
      </Box>
    </Box>
  );
};
